import {isEmpty} from 'lodash';

/**
 * Leaf module holding the current session's raw user resource. Both the
 * authentication module (which writes it on session bootstrap) and the error
 * notifier (which tags reports with account type / user id) read from here.
 * It must stay dependency-free (lodash aside): importing anything from
 * client/ or the notifier here recreates the module cycle
 * SessionStore -> authentication -> notifier -> SessionStore.
 */

let RAW_RESOURCE = {};

export function setSessionResource(user) {
  RAW_RESOURCE = user;
}

export function getSession() {
  const session = {
    getEmail: () => (RAW_RESOURCE.is_teacher ? RAW_RESOURCE.email : null),
    getId: () => RAW_RESOURCE.id || null,
    getLastAuthenticatedAt: () => RAW_RESOURCE.last_authenticated_at || null,
    getSignUpDate: () => RAW_RESOURCE.inserted_at || null,
    getDistrictCleverId: () => RAW_RESOURCE.district_clever_id || null,
    isSuper: () => Boolean(RAW_RESOURCE.super),
    isContentManager: () => Boolean(RAW_RESOURCE.is_content_manager),
    isAuthor: () => Boolean(RAW_RESOURCE.is_author),
    isTeacher: () => Boolean(RAW_RESOURCE.is_teacher),
    isSchoolAdministrator: () => Boolean(RAW_RESOURCE.is_school_administrator),
    isStudent: () => {
      return (
        !isEmpty(RAW_RESOURCE) &&
        Boolean(RAW_RESOURCE.id) &&
        !(
          Boolean(RAW_RESOURCE.is_teacher) ||
          Boolean(RAW_RESOURCE.is_school_administrator) ||
          Boolean(RAW_RESOURCE.is_author) ||
          Boolean(RAW_RESOURCE.super)
        )
      );
    },
    shouldResetPasswordOnLogin: () => Boolean(RAW_RESOURCE.reset_password_on_login),
    hasContentManagerAccess: () => {
      return Boolean(RAW_RESOURCE.is_content_manager) || Boolean(RAW_RESOURCE.super);
    },
    hasTeacherAccess: () => {
      return (
        Boolean(RAW_RESOURCE.is_teacher) ||
        Boolean(RAW_RESOURCE.is_school_administrator) ||
        Boolean(RAW_RESOURCE.super)
      );
    },
    hasAuthorAccess: () => {
      return (
        Boolean(RAW_RESOURCE.is_author) ||
        Boolean(RAW_RESOURCE.is_content_manager) ||
        Boolean(RAW_RESOURCE.super)
      );
    },
    isConfirmed: () => RAW_RESOURCE.status !== 'unconfirmed',
    isValid: () => !isEmpty(RAW_RESOURCE) && Boolean(RAW_RESOURCE.id),
    // Precedence matches SessionStore.getAccountType, which delegates here.
    getAccountType: () => {
      if (session.isSchoolAdministrator()) return 'administrator';
      if (session.isAuthor()) return 'author';
      if (session.isStudent()) return 'student';
      if (session.isSuper()) return 'super';
      if (session.isTeacher()) return 'teacher';
      return undefined;
    }
    // getRawResource: () => RAW_RESOURCE
  };
  return session;
}
